import React, { ReactNode, useState } from 'react';

import OrgLayoutContext from '@totem/components/orgManagement/layout/orgLayoutContext';

type Props = {
  children?: ReactNode;
};

const OrgLayoutContainer = ({ children }: Props) => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [selectedDrawer, setSelectedDrawer] = useState<string>('netSuiteKeys');

  const handleOpenDrawer = (drawerName: string): void => {
    setSelectedDrawer(drawerName);

    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
  };

  return (
    <OrgLayoutContext.Provider
      value={{
        drawerOpen,
        selectedDrawer,
        openDrawer: handleOpenDrawer,
        closeDrawer: handleCloseDrawer,
        setDrawer: setSelectedDrawer,
      }}
    >
      {children}
    </OrgLayoutContext.Provider>
  );
};

export default OrgLayoutContainer;
